import {
    HttpResponse,
    PanelDashboardModel,
    QueryModel,
    RequestParams,
    PanelDashboardModelIEnumerableApiResultSuccess,
    PanelDashboardModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class PanelDashboardsDataService implements CrudService<PanelDashboardModel, PanelDashboardModel> {
    getAll(query: CrudDataQuery<PanelDashboardModel>): Promise<CrudEnumerableResponse<PanelDashboardModel>> {
        return ApiService.api.getPanelDashboardBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<PanelDashboardModel>): Promise<CrudEnumerableResponse<PanelDashboardModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<PanelDashboardModel>> {
        return ApiService.api.getPanelDashboardById(id, params);
    }

    create(item: PanelDashboardModel, params?: RequestParams): Promise<CrudResponse<PanelDashboardModel>> {
        return ApiService.api.insertPanelDashboard(item, params);
    }

    update(item: PanelDashboardModel, params?: RequestParams): Promise<PanelDashboardModel> {
        return ApiService.api.updatePanelDashboard(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<PanelDashboardModel> {
        return ApiService.api.patchPanelDashboard(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<PanelDashboardModel>): Promise<CrudEnumerableResponse<PanelDashboardModel>> {
        return ApiService.api.deletePanelDashboards(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationPanelDashboard(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<PanelDashboardModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: PanelDashboardModel, params?: RequestParams): Promise<CrudResponse<PanelDashboardModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getPanelDashboardGroupped(query, params);
    }

}
